// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1j-Is","col":"styles_col__2yG8u"};